import { call, put } from 'redux-saga/effects';
import {
  fetchChartOfAccountsByCountryFailure,
  fetchChartOfAccountsByCountrySuccess,
} from '../actions';
import { fetchChartOfAccountsByCountry } from '../api';
import { FetchChartOfAccountsByCountryRequestAction } from '../types';
import { ApiError } from 'store/api/types';
import { checkResponse } from 'store/utils';
import { logoutRequest } from 'store/auth/actions';
import { MessageData } from 'store/app/types';
import { turnMessageOn } from 'store/app/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import { CoaAccountRow } from '../models';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* fetchChartOfAccountsByCountrySaga(
  action: FetchChartOfAccountsByCountryRequestAction
) {
  try {
    let err: ApiError | null;
    const { countryId } = action.payload;
    const response = yield call(fetchChartOfAccountsByCountry, countryId);

    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    const chartOfAccounts: CoaAccountRow[] = response?.data?.accounts ?? [];

    yield put(fetchChartOfAccountsByCountrySuccess(countryId, chartOfAccounts));
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(fetchChartOfAccountsByCountryFailure());
  }
}
